import React from 'react'

const CertificateRecipientInfo = ({ description, description2 }) => {
  return (
    <div className="certificate-issue-section">
      <h3 className="certificate-issue-section-title">발급자 정보</h3>
      <div className="certificate-issue-recipient">
        {description}
        <span className="certificate-issue-divider" />
        {description2}
      </div>
    </div>
  )
}

export default CertificateRecipientInfo
